import { NoDataComponent } from '@/shared/ui/components';
import classNames from 'classnames';
import Skeleton from 'react-loading-skeleton';
import { useSupportModules } from './useSupportModules';
import SupportModuleCard from './supportModuleCard/supportModuleCard';
import SupportModuleDetails from './supportModuleDetails/supportModuleDetails';
import type { SupportModulesProps } from './supportModules.types';
import './supportModules.scss';

/**
 * Renders the support modules tab, switching between the module grid and the detail view of a clicked module. While loading a full-height skeleton is shown, an empty result renders the no-data placeholder with a modifier class on the container, and otherwise every module from the hook becomes a card wired to the view handler.
 *
 * @param _props - Tab props, unused; all data comes from the support modules hook.
 * @returns The support module grid, its skeleton or empty state, or the selected module's details.
 */
const SupportModules = (_props: SupportModulesProps) => {
  const {
    isLoading,
    supportModules,
    clickedSupportModule,
    handleViewClick,
    handleBackClick,
    hasNoData,
  } = useSupportModules();

  return clickedSupportModule ? (
    <SupportModuleDetails supportModule={clickedSupportModule} handleBackClick={handleBackClick} />
  ) : (
    <div
      className={classNames('support-modules', {
        'support-modules--no-data': hasNoData,
      })}
    >
      {isLoading ? (
        <Skeleton height="100%" />
      ) : hasNoData ? (
        <NoDataComponent />
      ) : (
        <div className="support-modules__content">
          {supportModules.map((supportModule) => (
            <SupportModuleCard
              key={supportModule.id}
              supportModule={supportModule}
              handleViewClick={handleViewClick}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default SupportModules;
